import { Component, input, output } from '@angular/core';

@Component({
    selector: 'app-glossary-tag',
    imports: [],
    templateUrl: './glossary-tag.component.html',
    styleUrl: './glossary-tag.component.scss'
})
export class GlossaryTagComponent {
  text = input.required<string>();
  click = output<void>();
}
